module.exports = __webpack_public_path__ + "15.89fc093f.png";